const serverURL="https://socket-io-backend-sh3w.onrender.com";
// const serverURL="http://localhost:5000";

export {serverURL};